import { Box, Typography } from "@mui/material";
import { config } from "../../../../config";

export interface RealizationPopupCardProps {
  name: string;
  thumbnail?: string | null;
  onClick: () => void;
}

export const RealizationPopupCard = ({ name, thumbnail, onClick }: RealizationPopupCardProps) => (
  <Box
    onClick={onClick}
    sx={{ width: 240, cursor: "pointer" }}
  >
    {thumbnail && (
      <img
        src={`${config.baseUrl}/file/${encodeURI(thumbnail)}`}
        alt={name}
        style={{
          width: "100%",
          height: 160,
          objectFit: "cover",
          display: "block",
        }}
      />
    )}
    <Typography variant="subtitle2" sx={{ px: 1.5, py: 1, fontWeight: 600 }}>
      {name}
    </Typography>
  </Box>
);
